<template>
    <IndexHeader />
	<div class="main_video">
        <qiniu-video-player ref="player"></qiniu-video-player>
    </div>
</template>

<script setup>
    import IndexHeader from "../../components/IndexHeader/TopBar";
    import { getSignVideoUrl } from '../../server/jigou/course';
    import { ref, reactive, getCurrentInstance } from 'vue';
    import { useRouter,useRoute } from "vue-router";


    const route = useRoute();
    const player = ref(null);

    const init = () => {
        const id = route.query.id;
        
        getSignVideoUrl(id).then(res => {
            player.value.init({
                url: res.url
            })
        });
    }

    init();
</script>
<style scoped>
    .main_video{
        margin-top: 150px;
    }
    .main_video >>>div{
        margin: 0 auto;
    }
</style>